import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/use-auth';
import { Link } from 'react-router-dom';
import { useForm, SubmitHandler } from "react-hook-form";
import { CommonWrapper, CommonTitle, CommonLabel, CommonInput, CommonSubmit, CommonLinkWrapper } from 'styles/styles';

interface Inputs {
	email: string,
	password: string,
};


const App = () => {
	const auth = useAuth();

	const { register, handleSubmit, formState: { errors } } = useForm<Inputs>();
	const onSubmit: SubmitHandler<Inputs> = async data => {
		const result = await auth.forgotPassword(data.email);
		window.alert(result.message)
	}

	return (
		<>
			<form onSubmit={handleSubmit(onSubmit)}>
				<CommonWrapper>
					<CommonTitle>パスワードをお忘れの方</CommonTitle>
					<CommonLabel htmlFor="email">再設定用URL送信先メールアドレス</CommonLabel>
					<CommonInput {...register("email")} type="email" id="email" name="email" placeholder="メールアドレス" required />
					<CommonSubmit type="submit" value="パスワード再設定メール送信" />
					<CommonLinkWrapper><Link to={"/"}>ログインはこちら</Link></CommonLinkWrapper>
				</CommonWrapper>
			</form>
		</>
	)
}

const PasswordConfirmForm = () => {
	interface Inputs {
		verificationCode: string,
		password: string,
	};

	const auth = useAuth();
	const { register, handleSubmit, formState: { errors } } = useForm<Inputs>();

	const onSubmit: SubmitHandler<Inputs> = async data => {
		const res = await auth.forgotPasswordSubmit(data.verificationCode, data.password);
		window.alert(res.message);
	};

	return (
		<>
			<form onSubmit={handleSubmit(onSubmit)}>
				<CommonWrapper>
					<CommonTitle>認証コード入力</CommonTitle>
					<CommonLabel htmlFor="verificationCode">認証コード</CommonLabel>
					<CommonInput {...register("verificationCode")} type="verificationCode" id="verificationCode" name="verificationCode" required />
					<CommonLabel htmlFor="password">新しいパスワード</CommonLabel>
					<CommonInput {...register("password")} type="password" id="password" name="password" required />
					<CommonSubmit type="submit" />
				</CommonWrapper>
			</form>
		</>
	)
}

const GoToHome = () => {
	const navigate = useNavigate();
	useEffect(() => {
		alert("ログイン済みです");
		navigate("/home")
	}, [])


	return (
		<CommonWrapper>
			<CommonTitle>ログイン済</CommonTitle>
		</CommonWrapper>
	)
}

const ForgotPassword = () => {
	const auth = useAuth();
	if (auth.isAuthenticated) {
		return <GoToHome />
	}
	if (auth.waitingForVerificationCodeInput) {
		return <PasswordConfirmForm />;
	} else {
		return <App />;
	}
}

export default ForgotPassword;